<div class="row split-panel-container full-height">
    <cr-custom-field-list #list (deleteRow)="openDeleteModal($event)" (showDetails)="openEditModal($event)"></cr-custom-field-list>
    <custom-field-edit-modal #editModal (onUpdateSaved)="getCustomFields($event)"></custom-field-edit-modal>
    <custom-field-delete-modal #deleteModal (onDeleted)="getCustomFields($event)"></custom-field-delete-modal>
</div>